export default __webpack_public_path__ + "static/media/adventure.3669d948.png";